









import { Component, Vue, Prop } from 'vue-property-decorator';

import ShareButtons from '@/componentsV2/organisms/ShareButtons/ShareButtons.vue';

import { upperCaseFirstLetter } from '@/utils/string';

let timer: NodeJS.Timeout;

type GATracking = {
  eventCategory: string;
  eventAction: string;
};

@Component({
  components: {
    ShareButtons
  }
})
export default class ShareCampaign extends Vue {
  @Prop() gaTracking?: GATracking;
  @Prop() shareLink?: string;
  @Prop({ required: true }) origin!: string;

  handleAnalytics(socialNetwork: string) {
    if (!this.gaTracking) return;

    this.$analytics({
      ...this.gaTracking,
      eventLabel: `Clicked on "${upperCaseFirstLetter(socialNetwork)}" button`
    });
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get landingLink() {
    return this.business.branchLinks.landingPageLink;
  }
}
